import React, { useState } from 'react';
import './AdminLeaveHome.css';

// Icons
const ApproveIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const RejectIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const ViewIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EditIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeleteIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);

const FilterIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </svg>
);

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const PlusIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

// Sample employees data
const employees = [
  { id: 'TT100502', name: 'Pramodh Kumar Aitipamula' },
  { id: 'TT100503', name: 'Renuka VemiReddy' },
  { id: 'TT100002', name: 'Nidhi Singh' },
  { id: 'TT100500', name: 'Vinay Gaddam' },
  { id: 'TT100501', name: 'Gowsiya Syed' },
];

const leaveTypes = ['Casual Leave', 'Sick Leave', 'Loss Of Pay', 'Earned Leave', 'Maternity Leave', 'Paternity Leave'];

// Calendar Icon
const CalendarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

// Get current year and month
const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;

// Generate years array (2026, current year, and 5 years back)
const years = [2026, ...Array.from({ length: 6 }, (_, i) => currentYear - i)].filter((v, i, a) => a.indexOf(v) === i).sort((a, b) => b - a);

// Months array
const months = [
  { value: 0, label: 'All Months' },
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

const AdminLeaveHome = () => {
  const [activeTab, setActiveTab] = useState('pending');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');
  
  // Year and Month filter states
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  
  // Modal states
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);

  // Form state
  const [formData, setFormData] = useState({
    employeeId: '',
    leaveType: '',
    fromDate: '',
    toDate: '',
    reason: '',
    status: 'pending'
  });

  // Sample leave requests data
  const [leaveRequests, setLeaveRequests] = useState([
    {
      id: 1,
      employeeId: 'TT100502',
      employeeName: 'Pramodh Kumar Aitipamula',
      leaveType: 'Casual Leave',
      fromDate: '2025-01-15',
      toDate: '2025-01-17',
      days: 3,
      reason: 'Personal Work',
      status: 'pending',
      appliedOn: '2025-01-10'
    },
    {
      id: 2,
      employeeId: 'TT100503',
      employeeName: 'Renuka VemiReddy',
      leaveType: 'Sick Leave',
      fromDate: '2025-01-20',
      toDate: '2025-01-21',
      days: 2,
      reason: 'Medical Appointment',
      status: 'pending',
      appliedOn: '2025-01-18'
    },
    {
      id: 3,
      employeeId: 'TT100002',
      employeeName: 'Nidhi Singh',
      leaveType: 'Casual Leave',
      fromDate: '2025-01-05',
      toDate: '2025-01-06',
      days: 2,
      reason: 'Family Function',
      status: 'approved',
      appliedOn: '2025-01-02',
      approvedBy: 'Admin',
      approvedOn: '2025-01-03'
    },
    {
      id: 4,
      employeeId: 'TT100500',
      employeeName: 'Vinay Gaddam',
      leaveType: 'Loss Of Pay',
      fromDate: '2025-01-10',
      toDate: '2025-01-12',
      days: 3,
      reason: 'Personal Emergency',
      status: 'rejected',
      appliedOn: '2025-01-08',
      rejectedBy: 'Admin',
      rejectedOn: '2025-01-09',
      rejectionReason: 'Project deadline'
    },
    {
      id: 5,
      employeeId: 'TT100501',
      employeeName: 'Gowsiya Syed',
      leaveType: 'Sick Leave',
      fromDate: '2025-01-25',
      toDate: '2025-01-26',
      days: 2,
      reason: 'Fever',
      status: 'pending',
      appliedOn: '2025-01-24'
    }
  ]);

  // Filter requests based on year and month for stats
  const yearMonthFilteredRequests = leaveRequests.filter(request => {
    const requestDate = new Date(request.fromDate);
    const requestYear = requestDate.getFullYear();
    const requestMonth = requestDate.getMonth() + 1;
    
    const matchesYear = requestYear === selectedYear;
    const matchesMonth = selectedMonth === 0 || requestMonth === selectedMonth;
    
    return matchesYear && matchesMonth;
  });

  // Leave summary stats (based on year/month filter)
  const leaveStats = {
    pending: yearMonthFilteredRequests.filter(r => r.status === 'pending').length,
    approved: yearMonthFilteredRequests.filter(r => r.status === 'approved').length,
    rejected: yearMonthFilteredRequests.filter(r => r.status === 'rejected').length,
    total: yearMonthFilteredRequests.length
  };

  // Filter requests based on active tab, search, and year/month
  const filteredRequests = yearMonthFilteredRequests.filter(request => {
    const matchesTab = activeTab === 'all' || request.status === activeTab;
    const matchesSearch = request.employeeName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         request.employeeId.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesFilter = selectedFilter === 'all' || request.leaveType === selectedFilter;
    return matchesTab && matchesSearch && matchesFilter;
  });

  // Calculate days between dates
  const calculateDays = (from, to) => {
    if (!from || !to) return 0;
    const fromDate = new Date(from);
    const toDate = new Date(to);
    const diffTime = Math.abs(toDate - fromDate);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  };

  // Format date for display
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      employeeId: '',
      leaveType: '',
      fromDate: '',
      toDate: '',
      reason: '',
      status: 'pending'
    });
  };

  // CREATE - Open create modal
  const handleCreate = () => {
    resetForm();
    setShowCreateModal(true);
  };

  // CREATE - Submit new leave request
  const handleCreateSubmit = (e) => {
    e.preventDefault();
    const employee = employees.find(emp => emp.id === formData.employeeId);
    const newRequest = {
      id: Date.now(),
      employeeId: formData.employeeId,
      employeeName: employee ? employee.name : '',
      leaveType: formData.leaveType,
      fromDate: formData.fromDate,
      toDate: formData.toDate,
      days: calculateDays(formData.fromDate, formData.toDate),
      reason: formData.reason,
      status: formData.status,
      appliedOn: new Date().toISOString().split('T')[0]
    };
    setLeaveRequests([newRequest, ...leaveRequests]);
    setShowCreateModal(false);
    resetForm();
  };

  // READ - View leave details
  const handleView = (request) => {
    setSelectedRequest(request);
    setShowViewModal(true);
  };

  // UPDATE - Open edit modal
  const handleEdit = (request) => {
    setSelectedRequest(request);
    setFormData({
      employeeId: request.employeeId,
      leaveType: request.leaveType,
      fromDate: request.fromDate,
      toDate: request.toDate,
      reason: request.reason,
      status: request.status
    });
    setShowEditModal(true);
  };

  // UPDATE - Submit edited leave request
  const handleEditSubmit = (e) => {
    e.preventDefault();
    const employee = employees.find(emp => emp.id === formData.employeeId);
    const updatedRequests = leaveRequests.map(req => {
      if (req.id === selectedRequest.id) {
        return {
          ...req,
          employeeId: formData.employeeId,
          employeeName: employee ? employee.name : req.employeeName,
          leaveType: formData.leaveType,
          fromDate: formData.fromDate,
          toDate: formData.toDate,
          days: calculateDays(formData.fromDate, formData.toDate),
          reason: formData.reason,
          status: formData.status
        };
      }
      return req;
    });
    setLeaveRequests(updatedRequests);
    setShowEditModal(false);
    setSelectedRequest(null);
    resetForm();
  };

  // DELETE - Open delete confirmation
  const handleDeleteClick = (request) => {
    setSelectedRequest(request);
    setShowDeleteModal(true);
  };

  // DELETE - Confirm delete
  const handleDeleteConfirm = () => {
    setLeaveRequests(leaveRequests.filter(req => req.id !== selectedRequest.id));
    setShowDeleteModal(false);
    setSelectedRequest(null);
  };

  // Approve leave request
  const handleApprove = (requestId) => {
    const updatedRequests = leaveRequests.map(req => {
      if (req.id === requestId) {
        return {
          ...req,
          status: 'approved',
          approvedBy: 'Admin',
          approvedOn: new Date().toISOString().split('T')[0]
        };
      }
      return req;
    });
    setLeaveRequests(updatedRequests);
  };

  // Reject leave request
  const handleReject = (requestId) => {
    const updatedRequests = leaveRequests.map(req => {
      if (req.id === requestId) {
        return {
          ...req,
          status: 'rejected',
          rejectedBy: 'Admin',
          rejectedOn: new Date().toISOString().split('T')[0],
          rejectionReason: 'Rejected by admin'
        };
      }
      return req;
    });
    setLeaveRequests(updatedRequests);
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      pending: { label: 'Pending', className: 'status-pending' },
      approved: { label: 'Approved', className: 'status-approved' },
      rejected: { label: 'Rejected', className: 'status-rejected' }
    };
    return statusConfig[status] || statusConfig.pending;
  };

  const getAvatarUrl = (name) => {
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=2B4B99&color=fff&size=40`;
  };

  // Form input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="admin-leave-home">
      {/* Header with Filter and Create Button */}
      <div className="admin-leave-header">
        <div className="filter-section">
          <div className="filter-label">
            <CalendarIcon />
            <span>Filter by Period:</span>
          </div>
          <div className="filter-selectors">
            <div className="filter-select-group">
              <label>Year</label>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
                className="period-select"
              >
                {years.map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </div>
            <div className="filter-select-group">
              <label>Month</label>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(Number(e.target.value))}
                className="period-select"
              >
                {months.map(month => (
                  <option key={month.value} value={month.value}>{month.label}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <button className="create-btn" onClick={handleCreate}>
          <PlusIcon />
          Create Leave Request
        </button>
      </div>

      {/* Stats Cards */}
      <div className="leave-stats-grid">
        <div className="leave-stat-card pending">
          <span className="stat-number">{leaveStats.pending}</span>
          <span className="stat-label">Pending</span>
        </div>
        <div className="leave-stat-card approved">
          <span className="stat-number">{leaveStats.approved}</span>
          <span className="stat-label">Approved</span>
        </div>
        <div className="leave-stat-card rejected">
          <span className="stat-number">{leaveStats.rejected}</span>
          <span className="stat-label">Rejected</span>
        </div>
        <div className="leave-stat-card total">
          <span className="stat-number">{leaveStats.total}</span>
          <span className="stat-label">Total</span>
        </div>
      </div>

      {/* Filters and Search */}
      <div className="leave-controls">
        <div className="leave-tabs-admin">
          <button
            className={`tab-btn ${activeTab === 'all' ? 'active' : ''}`}
            onClick={() => setActiveTab('all')}
          >
            All
          </button>
          <button
            className={`tab-btn ${activeTab === 'pending' ? 'active' : ''}`}
            onClick={() => setActiveTab('pending')}
          >
            Pending
          </button>
          <button
            className={`tab-btn ${activeTab === 'approved' ? 'active' : ''}`}
            onClick={() => setActiveTab('approved')}
          >
            Approved
          </button>
          <button
            className={`tab-btn ${activeTab === 'rejected' ? 'active' : ''}`}
            onClick={() => setActiveTab('rejected')}
          >
            Rejected
          </button>
        </div>

        <div className="leave-search-filter">
          <div className="search-box">
            <SearchIcon />
            <input
              type="text"
              placeholder="Search by name or ID..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div className="filter-box">
            <FilterIcon />
            <select
              value={selectedFilter}
              onChange={(e) => setSelectedFilter(e.target.value)}
            >
              <option value="all">All Leave Types</option>
              {leaveTypes.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Leave Requests Table */}
      <div className="leave-table-container">
        <table className="leave-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Leave Type</th>
              <th>Duration</th>
              <th>Days</th>
              <th>Reason</th>
              <th>Applied On</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredRequests.length > 0 ? (
              filteredRequests.map((request) => {
                const statusBadge = getStatusBadge(request.status);
                return (
                  <tr key={request.id}>
                    <td>
                      <div className="employee-cell">
                        <img
                          src={getAvatarUrl(request.employeeName)}
                          alt={request.employeeName}
                          className="employee-avatar"
                        />
                        <div className="employee-info">
                          <span className="employee-name">{request.employeeName}</span>
                          <span className="employee-id">{request.employeeId}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className="leave-type-badge">{request.leaveType}</span>
                    </td>
                    <td>
                      <div className="duration-cell">
                        <span>{formatDate(request.fromDate)}</span>
                        <span className="duration-separator">to</span>
                        <span>{formatDate(request.toDate)}</span>
                      </div>
                    </td>
                    <td>
                      <span className="days-badge">{request.days} {request.days > 1 ? 'days' : 'day'}</span>
                    </td>
                    <td>
                      <span className="reason-text">{request.reason}</span>
                    </td>
                    <td>
                      <span className="applied-date">{formatDate(request.appliedOn)}</span>
                    </td>
                    <td>
                      <span className={`status-badge ${statusBadge.className}`}>
                        {statusBadge.label}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="action-btn view"
                          onClick={() => handleView(request)}
                          title="View Details"
                        >
                          <ViewIcon />
                        </button>
                        <button
                          className="action-btn edit"
                          onClick={() => handleEdit(request)}
                          title="Edit"
                        >
                          <EditIcon />
                        </button>
                        {request.status === 'pending' && (
                          <>
                            <button
                              className="action-btn approve"
                              onClick={() => handleApprove(request.id)}
                              title="Approve"
                            >
                              <ApproveIcon />
                            </button>
                            <button
                              className="action-btn reject"
                              onClick={() => handleReject(request.id)}
                              title="Reject"
                            >
                              <RejectIcon />
                            </button>
                          </>
                        )}
                        <button
                          className="action-btn delete"
                          onClick={() => handleDeleteClick(request)}
                          title="Delete"
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="8" className="no-data">
                  No leave requests found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* CREATE MODAL */}
      {showCreateModal && (
        <div className="modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Create Leave Request</h2>
              <button className="modal-close" onClick={() => setShowCreateModal(false)}>
                <CloseIcon />
              </button>
            </div>
            <form onSubmit={handleCreateSubmit} className="modal-form">
              <div className="form-group">
                <label>Employee</label>
                <select
                  name="employeeId"
                  value={formData.employeeId}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Employee</option>
                  {employees.map(emp => (
                    <option key={emp.id} value={emp.id}>{emp.name} ({emp.id})</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Leave Type</label>
                <select
                  name="leaveType"
                  value={formData.leaveType}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Leave Type</option>
                  {leaveTypes.map(type => (
                    <option key={type} value={type}>{type}</option>
                  ))}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>From Date</label>
                  <input
                    type="date"
                    name="fromDate"
                    value={formData.fromDate}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>To Date</label>
                  <input
                    type="date"
                    name="toDate"
                    value={formData.toDate}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Reason</label>
                <textarea
                  name="reason"
                  value={formData.reason}
                  onChange={handleInputChange}
                  placeholder="Enter reason for leave"
                  rows="3"
                  required
                />
              </div>
              <div className="form-group">
                <label>Status</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                >
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-cancel" onClick={() => setShowCreateModal(false)}>
                  Cancel
                </button>
                <button type="submit" className="btn-submit">
                  Create Request
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* VIEW MODAL */}
      {showViewModal && selectedRequest && (
        <div className="modal-overlay" onClick={() => setShowViewModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Leave Request Details</h2>
              <button className="modal-close" onClick={() => setShowViewModal(false)}>
                <CloseIcon />
              </button>
            </div>
            <div className="view-details">
              <div className="detail-row">
                <div className="detail-item">
                  <label>Employee</label>
                  <div className="detail-value employee-detail">
                    <img
                      src={getAvatarUrl(selectedRequest.employeeName)}
                      alt={selectedRequest.employeeName}
                      className="detail-avatar"
                    />
                    <div>
                      <span className="detail-name">{selectedRequest.employeeName}</span>
                      <span className="detail-id">{selectedRequest.employeeId}</span>
                    </div>
                  </div>
                </div>
                <div className="detail-item">
                  <label>Status</label>
                  <span className={`status-badge ${getStatusBadge(selectedRequest.status).className}`}>
                    {getStatusBadge(selectedRequest.status).label}
                  </span>
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-item">
                  <label>Leave Type</label>
                  <span className="detail-value">{selectedRequest.leaveType}</span>
                </div>
                <div className="detail-item">
                  <label>Days</label>
                  <span className="detail-value">{selectedRequest.days} {selectedRequest.days > 1 ? 'days' : 'day'}</span>
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-item">
                  <label>From Date</label>
                  <span className="detail-value">{formatDate(selectedRequest.fromDate)}</span>
                </div>
                <div className="detail-item">
                  <label>To Date</label>
                  <span className="detail-value">{formatDate(selectedRequest.toDate)}</span>
                </div>
              </div>
              <div className="detail-row full-width">
                <div className="detail-item">
                  <label>Reason</label>
                  <span className="detail-value">{selectedRequest.reason}</span>
                </div>
              </div>
              <div className="detail-row">
                <div className="detail-item">
                  <label>Applied On</label>
                  <span className="detail-value">{formatDate(selectedRequest.appliedOn)}</span>
                </div>
                {selectedRequest.approvedOn && (
                  <div className="detail-item">
                    <label>Approved On</label>
                    <span className="detail-value">{formatDate(selectedRequest.approvedOn)} by {selectedRequest.approvedBy}</span>
                  </div>
                )}
                {selectedRequest.rejectedOn && (
                  <div className="detail-item">
                    <label>Rejected On</label>
                    <span className="detail-value">{formatDate(selectedRequest.rejectedOn)} by {selectedRequest.rejectedBy}</span>
                  </div>
                )}
              </div>
              {selectedRequest.rejectionReason && (
                <div className="detail-row full-width">
                  <div className="detail-item">
                    <label>Rejection Reason</label>
                    <span className="detail-value rejection">{selectedRequest.rejectionReason}</span>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-actions">
              <button type="button" className="btn-cancel" onClick={() => setShowViewModal(false)}>
                Close
              </button>
              {selectedRequest.status === 'pending' && (
                <>
                  <button
                    type="button"
                    className="btn-approve"
                    onClick={() => {
                      handleApprove(selectedRequest.id);
                      setShowViewModal(false);
                    }}
                  >
                    Approve
                  </button>
                  <button
                    type="button"
                    className="btn-reject"
                    onClick={() => {
                      handleReject(selectedRequest.id);
                      setShowViewModal(false);
                    }}
                  >
                    Reject
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {showEditModal && selectedRequest && (
        <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Edit Leave Request</h2>
              <button className="modal-close" onClick={() => setShowEditModal(false)}>
                <CloseIcon />
              </button>
            </div>
            <form onSubmit={handleEditSubmit} className="modal-form">
              <div className="form-group">
                <label>Employee</label>
                <select
                  name="employeeId"
                  value={formData.employeeId}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Employee</option>
                  {employees.map(emp => (
                    <option key={emp.id} value={emp.id}>{emp.name} ({emp.id})</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Leave Type</label>
                <select
                  name="leaveType"
                  value={formData.leaveType}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Leave Type</option>
                  {leaveTypes.map(type => (
                    <option key={type} value={type}>{type}</option>
                  ))}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>From Date</label>
                  <input
                    type="date"
                    name="fromDate"
                    value={formData.fromDate}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>To Date</label>
                  <input
                    type="date"
                    name="toDate"
                    value={formData.toDate}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Reason</label>
                <textarea
                  name="reason"
                  value={formData.reason}
                  onChange={handleInputChange}
                  placeholder="Enter reason for leave"
                  rows="3"
                  required
                />
              </div>
              <div className="form-group">
                <label>Status</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                >
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-cancel" onClick={() => setShowEditModal(false)}>
                  Cancel
                </button>
                <button type="submit" className="btn-submit">
                  Update Request
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* DELETE CONFIRMATION MODAL */}
      {showDeleteModal && selectedRequest && (
        <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="modal-content delete-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Delete Leave Request</h2>
              <button className="modal-close" onClick={() => setShowDeleteModal(false)}>
                <CloseIcon />
              </button>
            </div>
            <div className="delete-content">
              <div className="delete-icon">
                <DeleteIcon />
              </div>
              <p>Are you sure you want to delete this leave request?</p>
              <div className="delete-info">
                <strong>{selectedRequest.employeeName}</strong>
                <span>{selectedRequest.leaveType} • {formatDate(selectedRequest.fromDate)} to {formatDate(selectedRequest.toDate)}</span>
              </div>
              <p className="delete-warning">This action cannot be undone.</p>
            </div>
            <div className="modal-actions">
              <button type="button" className="btn-cancel" onClick={() => setShowDeleteModal(false)}>
                Cancel
              </button>
              <button type="button" className="btn-delete" onClick={handleDeleteConfirm}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminLeaveHome;
